export const formatNumber = (value: unknown, fractionDigits: number = 0): string => {
	const num = typeof value === 'number' ? value : Number(value ?? 0);
	if (!isFinite(num)) return '';
	return num.toLocaleString(undefined, {
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	});
};
